import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';

import styles from './index.module.scss';

export interface SpeechBubbleProps extends HTMLAttributes<HTMLDivElement> {
  readonly type?: 'small' | 'medium' | 'large' | 'promo';
}

export function SpeechBubble({
  type = 'small',
  className,
  children,
  ...props
}: SpeechBubbleProps): JSX.Element {
  return (
    <div className={classNames(styles.SpeechBubble, styles.shadow, styles[type], className)} {...props}>
      {children}
    </div>
  );
}
SpeechBubble.displayName = 'SpeechBubble';
